import React, { createContext, useContext } from 'react';
export type TRuntimeConfig = {
  otpEnabled: boolean;
};
const defaultRuntimeConfig: TRuntimeConfig = {
  otpEnabled: false
};
const RuntimeConfigContext = createContext<TRuntimeConfig>(defaultRuntimeConfig);
type TRuntimeConfigProviderProps = {
  config: TRuntimeConfig;
  children: React.ReactNode;
};
export const RuntimeConfigProvider = ({
  config,
  children
}: TRuntimeConfigProviderProps) => <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
export const useOtpEnabled = () => useContext(RuntimeConfigContext).otpEnabled;